import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { useLocale } from 'locale';
import { useSendEvent } from 'analytics/useSendEvent';
import ArrowIcon from 'assets/svg/right.svg';
import { Text } from 'ds/components/typography';
import BackLink, { backLinkConfigSelector } from 'components/navigation/BackLink';

const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

const Root = styled.div<{ noMarginBottom: boolean }>(({ theme, noMarginBottom }) => ({
  'a': {
    display: 'inline-block',
    color: theme.colors.neutrals.grey1,
    textDecoration: 'none',
  },
  marginBottom: noMarginBottom ? 0 : theme.spacing(2),
}));

export const BackButton: React.FC<{ noMarginBottom?: boolean }> = React.memo(({ noMarginBottom = false }) => {
  const { t } = useLocale();
  const config = useSelector(backLinkConfigSelector);
  const sendEvent = useSendEvent();
  const isSimilar = Boolean(config && config.isSimilarListings);

  const handleClick = () => {
    if (isSimilar) {
      sendEvent('similar_listings_landing_click', 'property', {
        tracking_search_source: 'similar_listings_landing',
      });
    }
  };

  return (
    <Root noMarginBottom={noMarginBottom} onClick={handleClick}>
      <BackLink>
        <Wrapper>
          <ArrowIcon width={24} height={24}/>
          <Text weight="medium" data-auto="back-button-text">
            {isSimilar ? t('listingPage.similarListings') : t('listingPage.back')}
          </Text>
        </Wrapper>
      </BackLink>
    </Root>
  );
});
